export const TEXT = {
	HEADER_TITLE: "Arizona DHIA Micro Results"
}

export const CSS_CLASSES = {
	HEADER_RIGHT_SIDE: "header-right-side-container"
}